import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	pageTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pageTitleForYou: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pageTitleYourWork: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	pageTitle: {
		id: 'home.document-title.page-title',
		defaultMessage: 'For you - {appTitle}',
		description:
			'The title for the Jira home page. The appTitle placeholder is the name of the Jira instance.',
	},
	pageTitleForYou: {
		id: 'home.document-title.page-title-for-you',
		defaultMessage: 'For you',
		description: 'The title for the Jira home page.',
	},
	pageTitleYourWork: {
		id: 'home.document-title.page-title-your-work',
		defaultMessage: 'Your work',
		description: 'The old title for the Jira home page.',
	},
});
export default messages;
